import React, { useEffect, useState } from "react";
import moment from "moment";
import ProductComponent from "../../components/product/ProductComponent";
import Loading from "../../../components/isLoading";
import { fetchProductData } from "../../../redux/products/index";
import { Edit, Publish, DeleteForever } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import DeleteModel from "../DeleteModel";
import ConfirmModel from "../ConfirmModel";
import { DELETE_PRODUCT } from "../../../redux/products/types";

const ProductContainer = (props) => {
  const { id } = props;
  const [state, setState] = useState({
    openDeleteMessage: false,
    openConfirmation: false,
  });
  const productData = useSelector((state) => state.productGlobalStore);
  const deleteStore = useSelector((store) => store.deleteProductGlobalStore);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(fetchProductData(id));
    }
  }, []);

  const handleOnEdit = () => navigate("edit");

  const handleOpenCloseConfirmModel = (condition) =>
    setState((prevState) => ({ ...prevState, openConfirmation: condition }));

  const handleOpenCloseDeleteModel = (condition) =>
    setState((prevState) => ({ ...prevState, openDeleteMessage: condition }));

  const isUnpublish = productData.data?.status === "published";
  const crumps = [
    {
      title: "Products",
      path: "/products",
    },
  ];
  const actions = [
    {
      onClick: handleOnEdit,
      text: "Edit Product",
      icon: <Edit fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseConfirmModel(true),
      text: isUnpublish ? "Unpublish Product" : "Publish Product",
      icon: <Publish fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseDeleteModel(true),
      text: "Delete Product",
      icon: <DeleteForever fontSize="small" />,
    },
  ];

  return productData.loading ? (
    <Loading />
  ) : (
    <div>
      <DeleteModel
        isOpen={state.openDeleteMessage}
        isFor="Products"
        handleCloseModel={() => handleOpenCloseDeleteModel(false)}
        itemId={id}
        store={deleteStore}
        action={DELETE_PRODUCT}
      />
      <ConfirmModel
        isOpen={state.openConfirmation}
        isFor="Products"
        handleCloseModel={handleOpenCloseConfirmModel}
        itemId={id}
        isUnpublish={isUnpublish}
      />
      <ProductComponent
        product={productData.data || {}}
        crumps={crumps}
        actions={actions}
      />
    </div>
  );
};

export default ProductContainer;
